import React from 'react';
import backgroundImage from '../background.webp';
import cardbackground from '../cardbackground.webp'; // Import card background image
import buttonImage from '../buttonimage.webp'; // Add this import
import { supabase } from '../supabaseClient';

export default function IdentifyTheFeeling({ goBack, goHome }) {
    const handleSaveProgress = async () => {
        try {
            const { data: { user }, error: userError } = await supabase.auth.getUser();
            if (userError || !user) {
                console.error('Error fetching user:', userError);
                alert('User not logged in!');
                return;
            }

            const { error: progressError } = await supabase
                .from('user_progress')
                .upsert({
                    user_id: user.id,
                    current_question_id: null,
                    current_component: 'healingFormulasPage/identifyTheFeeling',
                    animated_helper: 'no', // <-- always set to 'no'
                    timestamp: new Date().toISOString(),
                });

            if (progressError) {
                console.error('Error saving progress:', progressError.message);
                alert('Failed to save progress: ' + progressError.message);
                return;
            }

            alert('Progress saved successfully!');
        } catch (err) {
            console.error('Unexpected error saving progress:', err);
            alert('An unexpected error occurred while saving progress.');
        }
    };


    const textStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        lineHeight: '1.5',
        marginBottom: '16px',
    };

    const listStyle = {
        fontFamily: 'Times New Roman, Times, serif',
        fontSize: '14px',
        fontWeight: 'bold',
        color: 'black',
        textAlign: 'center',
        lineHeight: '1.5',
        marginBottom: '8px',
    };

    return (
        <>
            <style>
                {`
                @media (max-width: 600px) {
                    .identify-feeling-nav-row {
                        flex-direction: row !important;
                        gap: 6px !important;
                        width: 100% !important;
                        justify-content: space-between !important;
                        margin: 0 !important;
                        padding: 0 2vw 0 2vw !important;
                    }
                    .identify-feeling-nav-row button {
                        width: 32vw !important;
                        min-width: 0 !important;
                        max-width: 110px !important;
                        font-size: 15px !important;
                        padding: 10px 0 !important;
                        margin: 0 !important;
                    }
                }
                `}
            </style>
            <div
                style={{
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '20px',
                }}
            >
                <h2
                    style={{
                        fontFamily: 'Times New Roman, Times, serif',
                        fontSize: '36px',
                        fontWeight: 'bold',
                        color: '#4B5563',
                        textAlign: 'center',
                        marginTop: '16px',
                    }}
                >
                    Identify the Feeling
                </h2>
                {/* Session Helper Cards Row */}
                <div
                    className="identifythefeeling-session-helper-row"
                    style={{
                        display: 'flex',
                        flexDirection: window.innerWidth <= 600 ? 'column' : 'row',
                        gap: '16px',
                        width: '100%',
                        maxWidth: '600px',
                        marginBottom: '16px',
                    }}
                >
                    {/* Left Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardbackground})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                        marginBottom: window.innerWidth <= 600 ? '16px' : 0,
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>• Feelings are Data points. They offer us information</div>
                            <div>• We are not our feelings</div>
                            <div>• Feelings can get stuck looping when we have an experience too confusing or too overwhelming to process</div>
                            <div>• Processing Feelings means being present while the feeling is with us instead of distracting, denying, supressing, or projecting</div>
                            <div>• Naming a feeling is not necessary but it can help us understand</div>
                            <div>• Google search a list of feelings to help you identify the feeling if needed</div>
                        </div>
                    </div>
                    {/* Right Card */}
                    <div style={{
                        flex: 1,
                        border: '2px solid black',
                        borderRadius: '10px',
                        padding: '16px',
                        textAlign: 'left',
                        backgroundImage: `url(${cardbackground})`,
                        backgroundSize: 'cover',
                        boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    }}>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '18px', marginBottom: '10px', textAlign: 'center' }}>*Session Helper*</div>
                        <div style={{ fontFamily: 'Times New Roman, Times, serif', fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                            <div>1. Do you feel comfortable feeling your feelings?</div>
                            <div>2. Is there anything in your energy waiting to be felt right now?</div>
                            <div>3. Do you feel comfortable with allowing your feelings to move through you even if they come with tears or laughter?</div>
                            <div>4. Has there ever been a time when you were unfairly judged for your feelings?</div>
                            <div>5. Have you ever experienced an uncontrollable behavior playing out in yourself in response to your feelings?</div>
                            <div>6. Are there any feelings that you will not allow yourself to feel?</div>
                        </div>
                    </div>
                </div>
                {/* 3rd card: start of stacked column, ensure same width as others */}
                <div style={{
                    width: '100%', // match column card width
                    maxWidth: '600px', // match column card maxWidth
                    border: '2px solid black',
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <p style={textStyle}>
                        The feelings we have associated with our experiences are directly related to the interpretation or the story we tell ourselves about the experiences. Whenever we make the experience mean something that it does not actually mean, we create a potential for a loop where we will experience the same thing with another opportunity to rectify our conclusions.
                    </p>
                    <p style={textStyle}>
                        The way that our misunderstandings can create the loop is that the explanation we have for the experience may have us denying or justifying the feelings that arose with the experience. The feeling is the anchor that keeps the experience looping and is also the key to releasing the experience when we are done studying it.
                    </p>
                    <p style={textStyle}>
                        Whenever the experience has caused us overwhelming feelings that we don't allow ourselves to process or that we feel unable to process, the experiences that cause that feeling will repeat in our lives in order to give us more opportunity to process the feelings. Whenever we are able to be present with the feelings, they will continue to move through us and will not lock in a looping pattern.
                    </p>
                    <p style={textStyle}>
                        Whenever we can be with the feelings in presence, they will move on their own in a natural way. Sometimes when the experience has caused us overwhelm, we may develop coping mechanisms that are designed to help us avoid having to face that feeling again. Our coping mechanism plays out like a trance that is activated next time the opportunity to process the emotion tries to arise.
                    </p>
                    <p style={textStyle}>
                        Only when we become aware of this coping mechanism can we consciously choose to change the pattern and be present with the feeling. When we have these coping mechanisms in place, it can be difficult to identify the feeling we are avoiding because we will tend to skim right over it automatically. The process becomes unconscious and repeats until we are ready to overcome it.
                    </p>
                </div>
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black', // ensure black border
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <p style={textStyle}>
                        Some tips for allowing yourself to identify that there is a feeling hidden within your coping mechanism are:
                    </p>
                    <p style={listStyle}>1. Slow down.</p>
                    <p style={listStyle}>2. Be open to seeing into yourself deeper.</p>
                    <p style={listStyle}>3. Be brave.</p>
                    <p style={listStyle}>4. Practice making space for the feeling to be there.</p>
                    <p style={listStyle}>5. Make space between the experience you are having and your reaction.</p>
                    <p style={listStyle}>6. Look up a feelings wheel and identify the matching feeling on the wheel.</p>
                    <p style={listStyle}>7. Ask yourself why you do not feel anything in the experience when you think you should.</p>
                </div>
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black', // ensure black border
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    {/* SAMPLE TEXT CARD - this is the missing card */}
                    <p style={textStyle}>
                        Everything is Energy. <br /> Every Energy exists on an axis. <br /> We can experience one or both sides of an energy, but both sides always exist.  We can be fixed at a point on the scale based on our beliefs or unprocessed life experiences. <br /> Understanding our own fixed perception fully can open us to see the bigger picture of the full axis again. <br />  The energy on the axis can either be expansive or contracting. <br /> Contracting energy experiences do not feel comfortable and are limiting.  Expansive energy experiences can be uncomfortable and are unlimited. <br />  Growth comes from pushing through the discomfort to allow the limitless possibilities that exist. <br /> Courage is required to pass from contracted to expansive states. Becoming the version of ourselves that can be with the discomfort frees us to utilize the needed courage. 
                    </p>
                    <img
                        src="/images/energyscalejpg.webp"
                        alt="Energy Scale"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginTop: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain'
                        }}
                    />
                </div>
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black', // ensure black border
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    {/* LAST CARD ABOVE NAV BUTTONS */}
                    <img
                        src="/images/signs%20of%20emotions%20avoided.webp"
                        alt="Signs of Emotions Avoided"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginBottom: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain'
                        }}
                    />
                </div>
                {/* New Card with Responsibility Punishment image */}
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black', // ensure black border
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <img
                        src="/images/responsibility%20punishment.webp"
                        alt="Responsibility Punishment"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginBottom: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain'
                        }}
                    />
                </div>
                {/* New Card with Love self meme image */}
                <div style={{
                    width: '100%',
                    maxWidth: '600px',
                    border: '2px solid black', // ensure black border
                    borderRadius: '10px',
                    backgroundImage: `url(${cardbackground})`,
                    backgroundSize: 'cover',
                    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
                    marginBottom: '20px',
                    padding: '20px',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                }}>
                    <img
                        src="/images/loveselfmeme.webp"
                        alt="Love Self Meme"
                        style={{
                            width: '100%',
                            maxWidth: '360px',
                            height: 'auto',
                            marginBottom: '12px',
                            borderRadius: '8px',
                            border: '1px solid #4B5563',
                            objectFit: 'contain'
                        }}
                    />
                </div>
                {/* New Card with image and expandable text */}
                <ExpandableFeelingGuideCard />
                <div
                    className="identify-feeling-nav-row"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        gap: '16px',
                        marginTop: '0',
                        marginBottom: '16px',
                        width: '100%',
                    }}
                >
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={goBack}
                    >
                        Back
                    </button>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={goHome}
                    >
                        Home
                    </button>
                    <button
                        style={{
                            backgroundImage: `url(${buttonImage})`,
                            backgroundSize: 'cover',
                            color: 'white',
                            border: '2px solid black',
                            borderRadius: '10px',
                            padding: '10px 20px',
                            fontFamily: 'Times New Roman, Times, serif',
                            fontSize: '16px',
                            fontWeight: 'bold',
                            cursor: 'pointer',
                        }}
                        onClick={handleSaveProgress}
                    >
                        Save
                    </button>
                </div>
            </div>
        </>
    );
}

/** Add this component at the bottom of the file (outside the main component) **/
function ExpandableFeelingGuideCard() {
    const [expanded, setExpanded] = React.useState(false);
    const paragraphs = [
        `How to Feel Your Feelings - It might seem strange that I am sharing about how to do something that humans naturally do.  But another thing that humans naturally do is... Survive. When a human encounters an experience that causes overwhelming emotions and those emotions are interpreted as negative; and the human needs to survive the overwhelm, they will utilize a coping mechanism for handling the situation.`,
        `Sometimes the way of coping will be to suppress, deny, project, avoid, numb out, escape, or delude themselves.`,
        `Because of the nature of relating patterns and beliefs systems that currently permeate our society, this need to cope with overwhelming emotions can happen quite often.`,
        `The majority of our operating system is adopted during our first seven years of life.  This time period is for forming our operating system, by taking in information from our environment.  When we experience overwhelming emotion as a child we will either adopt the example of our caretaker or peers, or adapt our own if no example is available.`,
        `In this way, it is understandable to realize that we have been perpetuating some unhealthy coping mechanisms in our society, simply by virtue of our being an example to our children who learn from what we do, not from what we tell them to do.  When we parent children by telling them what to do, or what not to do, we simply make that part of the operating system they live with.`,
        `Now the operating system is held in the subconscious, meaning it is below the level of awareness.  So an adult trying to understand this concept might wonder if it can be true since they were told what to do by their parents, but they don't let people tell them what to do as an adult.`,
        `This can be easily explained.  Since the operating system is in the subconscious, below the level of awareness, the adult likely does not realize that the program that was downloaded into them which taught them to look outside themselves to be told what to do is the reason they have decided to cope the way they do.  The adult may make it a point to never let themselves be told what to do in certain circumstances in order to rebel against what was done to them as a child.`,
        `Now the healthy critically thinking adult may say.. "then what is the point? Why does it matter what my parents did if I can still do what I want anyway?" The thing is
.. because the need to rebel against being told what to do is a coping mechanism, that means there will be times when it behooves this person to listen to outside advice or perspectives and they will automatically refuse.  In some cases this could cause them more issues. For example... If driving along and encounter a traffic signaler telling them to take another route.. but they refuse and find themselves stuck in traffic for 3 hours.  This adult is still capable of learning and adapting, so it is unlikely that they will ignore a traffic signaler again.  This coping mechanism of avoiding being told what to do could accumulate many experiences that cause this adult to "learn the hard way".  This is all done in an effort to avoid the uncomfortable feeling of being told what to do as a child.`,
        `In the child stage of up to 7 years there is a curiosity that leads a child to explore the environment.  This is completely innocent and by design will cause them to download the operating system that is required to live in the environment. So, ideally as parents we foster this sense of curiosity by allowing it and keeping the child safe to do it. However in a culture where pride, image, expectation, attachment to outcome, abuse and power struggles has been a part of our programming, it is understandable that parents have used their authority over Children to mold them, and encourage them to behave in expected manners by telling them how to act, rather than encouraging their exploration of the environment.  This is how patterns of functioning and relating, or dysfunctional patterns of relating have been passed down to our younger generation.`,
        `We have taught them that it is appropriate to expect others to live up to our standards, want others to do as we wish, and even shame others into compliance.`,
        `Really these are just ways of coping with life, and they prove to be troublesome in the long run.  Instead of being present with our children while they explore, assisting their safety and taking a genuine interest on who they are here to become, we have allowed ourselves to dictate all of that, which does cause an internal separation in the child between what they are drawn to, and what is expected of them.  If we punish a child's natural curiosity, or right to make mistakes in order to learn, then we model conditional love to that child.`,
        `So, as a child who has an inner urge to explore the world is given the impression that is wrong, or they are wrong, this causes a need to cope with whatever feeling arises in response to that.  If children feel overwhelmed and cry out, kicking and screaming, and are in turn shunned or punished... We teach them to shun or punish their emotions.`,
        `In order to adapt to a need to shun or punish emotions as an adult it makes sense that people would use substance to escape feeling it, or suppress and deny when possible.  Coping mechanisms vary between people, and none of them are wrong.`,
        `The purpose of this is not to punish our parents or say they were wrong. We are an evolving species. This is an effort to explain the cause and effect.  The reason is because in understanding how this works we can also understand that we can evolve out of these ways too.`,
        `Now, in the case of rebel operating in such a way as to not let self be told what to do; in order to release the operating program, he is currently held to, he will want to notice that in the split second before he chooses to rebel, there is a feeling.. he hasn't let himself feel it in years.  So let's dig a little and see what we can find.  Before we uproot any uncomfortable feelings, it is important to make sure we are in the right space.  Mind and body must be cared for through this process.  Some people have programs in their subconscious that tell them it is selfish or pointless to take such focus and care with self.  It is like a Jenga tower when we start digging in the subconscious and so I would like to mention that we don't really need to dig until the coping mechanism is in our awareness, and ready to be healed.`,
        `We are using this example just to show how it can be done.`,
        `You will know when something you have been doing is ready to be more fully understood because you will be able to acknowledge it.  Sometimes this happens after we notice the pattern in ourselves of always reacting a certain way.`,
        `So, what is a safe space for you? Where can you be comfortable enough to unpack your buried treasure? That is right, I called it buried treasure because as we release ourselves from the coping mechanisms that have been keeping us from our uncomfortable feelings, we gain a feeling of freedom and wholeness; which is certainly something I have treasured.  I also find that as I clear away my need to cope, by replacing it with a willingness to love myself unconditionally, that the skills I learned, and the experiences I had while coping in that way are valuable to me and become part of the treasure I find myself to be.`,
        `A safe space might look like a therapists office, or your bed, a walk in the woods, or sitting at your desk with a journal.  When you are ready to proceed you want to have a plan for how you will handle the feelings that arise.  One thing I found important was to reassure myself that I would not abandon myself while I feel what comes up, and that I would not act out my feelings in any way that could harm myself or another(including property).`,
        `When I first started clearing up my backlog of so far unloved emotions in myself I spent every day, for awhile, in the bathtub for hours...just remembering and crying.`,
        `While I cried I made it a point to be aware that I was allowed to feel whatever I feel.  That if I felt it, it was valid.  I wasn't taking any action on feelings of anger or hopelessness.. so it was just a matter of being present with myself as I allowed myself to be, to feel, and to know that I was worth taking the time to know.  I was learning about myself as I cried myself into exhaustion.`,
        `Sometimes I would imagine filling my body with light from source.  I always had crystals in the bath with me.  I used Epsom salt in my bath as well as essential oils.  Later I didn't need to designate so much time to my catharsis.  Eventually I had retrained myself in the handling of uncomfortable emotions and now can stay fully present while I process discomfort in real time. By doing this I have also learned that I really do love myself, and earned my own trust back to know that I can handle whatever arises. First I had to deal with the backlog of all of the stuff I had not yet processed.`,
        `When we don't have the tools or understanding to process we end up with symptoms like depression, anxiety, and addiction. I used to be heavily medicated with psychiatric drugs for these type symptoms, as well as suffer from PTSD symptoms and irrational fears.  Just by taking the time to process each thing that was ready to be seen, I have alleviated those symptoms and the need to medicate in any way.  I don't even use cannabis or alcohol because I really just see the value in facing what is, head on, and being present with myself at all times.  This is the life I get to live, and I don't want to miss a thing.`,
        `So, in whatever safe space you find for yourself, when you are ready, there are some questions you can ask yourself to find out what is at the root of the coping mechanism in question. These questions came from Teal Sean, who has a wonderful array of spiritual advice on her YouTube channel.`,
        `Let's use the example of not wanting to be told what to do.
Ask, "What would be so bad about that?" Sometimes/often the coping mechanism we have is designed to avoid being questioned. It has valid reasons for everything it is doing.. in it's view.  But, the view of this coping mechanism (as if it's a rogue part of self operating for its own agenda, which it is) is fragmented, as it only sees it's own agenda, which is to avoid this uncomfortable feeling that you are now digging for.  Therefore, commonly attention will need to be redirected toward the line of questions and intention of answering honestly in order to achieve anything with this method.`,
        `So whatever the answer is, you ask again "what would be so bad about that?" Keep asking this question or replace it with "what does that mean to you?" When appropriate, until you get to the deep seated fear that is associated with why you are operating in this manner.`,
        `Now that you have a root cause you may want to meditate, or reminisce about an earlier memory associated with this cause.  It is not always possible to find a memory within ourselves.  The next steps will require more tools and the main focus of this article is meant to assist with feeling the emotion. So I will say that there are methods where you can revisit a memory and give yourself what you need in the memory, and even retrieve parts of yourself that still exist in that memory. Look for a YouTube video about this on my channel, to find out more.`,
        `For now we are going to process emotion, which is really just a wave of energy.. and the way we interpret that energy dictates how we feel.  So when we are overwhelmed and we interpret a threat, that is when we can end up suppressing a feeling and developing a coping mechanism to avoid feeling it ever again.`,
        `These coping mechanisms require our free will and intention to dissipate them.  If we simply decide to act in a way opposite to what we were doing to cope when we realized it wasn't working well for us overall, we will still be under the influence of the avoidance of the uncomfortable feeling and therefore will eventually find a need to change that new behavior too.  All of our behaviors we use to cope will be designed to ultimately fail and finally bring us back to the feeling in order to accept that it exists.  Let it be with us.  Love ourselves through experiencing it.  This is actually what we wanted our parent to do when we were overwhelmed.  We wanted to know that we could handle it; and now we need to be the parent for ourselves. Let yourself know that despite the big feelings that you can handle feeling it and that it is appropriate to do so.  Our human vessel has been equipped with the benefit of feeling.  We have a navigation system that can lead us when we understand how it works.  All that becomes a lot more clear when we process the backlog of what we have not yet been present with in ourselves.`,
        `So, slow down and be in that safe space and ask self, for example, what does it FEEL like when someone tells me what to do?
That feeling has been suppressed and denied so many times by now that it may not trust that you are really here for it.  Be patient and persistent with your presence for the feeling. Relax.. ask your body where it is stored.  Ask the feeling what it needs. Reassure the feeling of your intentions to be with it, and accept it, and welcome it in to the bigger more whole part of you who has handled everything you had to traverse in life up to now.`,
        `Be ready to cry and cry.. to get hot, and perhaps even have the feeling that you want to die... It can all be processed through with presence.  If you do not feel safe doing it alone then get some help for your comfort zone.  This ultimately is our responsibility now.. to give ourselves what we need.`,
        `Some of us have been programmed with the idea that we should not ask for anything... but if we get quiet and really listen we know that comes from a fear, and this is your permission...  You are worth the time and effort.`,
        `It does require Bravery and taking responsibility, and these are skills that you have.  Sometimes there are programs in the way of feeling capable of these things.  When we find something in our way... It is in front of us because it's time for it to be seen. Please don't hesitate to utilize your resources and reach out for help when you need it.  Anyone who has ever known themselves to be Brave, only knows it is so because they know there was a time when it was not possible. Whatever challenges we face and whatever dis-empowered state we find ourselves in are part of the path of getting to where we are going.  Use what you know but be sure to experiment as you go.  We don't really gain anything from knowing what we are told, it is in the living and the experiencing that we find out who we are.`
    ];

    return (
        <div style={{
            width: '100%',
            maxWidth: '600px',
            border: '2px solid black',
            borderRadius: '10px',
            backgroundImage: `url(${cardbackground})`,
            backgroundSize: 'cover',
            boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
            marginBottom: '20px',
            padding: '20px',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
        }}>
            <img
                src="/images/dlsuppressedrepresseddenied.webp"
                alt="Suppressed Repressed Denied"
                style={{
                    width: '100%',
                    maxWidth: '360px',
                    height: 'auto',
                    marginBottom: '12px',
                    borderRadius: '8px',
                    border: '1px solid #4B5563',
                    objectFit: 'contain'
                }}
            />
            <div style={{
                fontFamily: 'Times New Roman, Times, serif',
                fontSize: '14px',
                color: 'black',
                textAlign: 'left',
                lineHeight: '1.5',
                width: '100%'
            }}>
                <p>{paragraphs[0]}</p>
                {!expanded && (
                    <span
                        style={{
                            color: '#2563eb',
                            cursor: 'pointer',
                            fontWeight: 'bold',
                            textDecoration: 'underline'
                        }}
                        onClick={() => setExpanded(true)}
                    >
                        more
                    </span>
                )}
                {expanded && paragraphs.slice(1).map((para, idx) => (
                    <p key={idx} style={{ marginTop: '12px' }}>{para}</p>
                ))}
            </div>
        </div>
    );
}
